class BuyingGuideSpecs extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-specs-toggle]');
    this.label = this.querySelector('[data-specs-toggle-label]');
    this.expandLabel = this.toggle?.textContent?.trim() || '+ Show all specifications';
    this.collapseLabel = '- Hide specifications';

    this.toggle?.addEventListener('click', () => {
      const expanded = this.classList.toggle('is-expanded');
      this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (this.label) {
        this.label.textContent = expanded ? this.collapseLabel : this.expandLabel;
      }
    });
  }
}

if (!customElements.get('buying-guide-specs')) {
  customElements.define('buying-guide-specs', BuyingGuideSpecs);
}
